import { get, post } from '../requestNew';
import { baseUrl } from '../utils';

export type Audience = { type: string; gameSession?: string; groupType?: number; paymentScope?: 'ALL' | 'FREE' | 'PAID'; memberScope?: string; openId?: string };
export type SendRequest = { requestId: string; audience: Audience; contentType: number; content: string };
export type SendResult = { messageId: number; recipientCount: number; snapshotAt: string };
export type Options = {
  types: string[]; memberScopes: string[];
  seasons: { gameSession: string; gameSessionName: string }[];
  groups: { groupType: number; groupTypeName: string }[];
};
export type Candidate = { openId: string; gameName: string; maskedPhone: string; openIdSuffix: string };
export type Preview = { recipientCount: number; canSend: boolean; reason?: string; audience?: Record<string, unknown> };
export type HistoryRow = SendResult & { content: string; contentType: number; sendTime: string; audienceType: string; audienceParams: string; operatorName: string };
export type Page<T> = { list: T[]; total: number };
const prefix = '/backend/systemMessage/notify';
export async function read<T>(path: string, params: Record<string, unknown> = {}): Promise<T> {
  const response = await get<{ data: T }>(prefix + path, params, () => undefined);
  return response.data;
}
export async function write<T>(path: string, body: object): Promise<T> {
  const response = await post<{ data: T }>(prefix + path, body, () => undefined);
  return response.data;
}
export function errorText(error: unknown): string {
  const e = error as { response?: { data?: { message?: string }; status?: number }; message?: string };
  return e?.response?.data?.message || e?.message || '请求失败，请重试';
}
export function errorCode(error: unknown): number | undefined {
  const e = error as { response?: { status?: number }; code?: number };
  return e?.response?.status || e?.code;
}
export const audienceNames: Record<string, string> = { USER: '指定用户', SEASON: '赛季报名用户', SEASON_GROUP: '赛季分组用户', MEMBER: '会员用户' };
export const paymentNames: Record<string, string> = { ALL: '全部', FREE: '免费', PAID: '付费' };
export const memberNames: Record<string, string> = { MEMBER: '复利会员', REVIEW: '复盘会员', UNION: '两类会员（去重）' };
export function audienceDescription(row: Pick<HistoryRow, 'audienceType' | 'audienceParams'>): string {
  try {
    const p = JSON.parse(row.audienceParams);
    return [audienceNames[row.audienceType] || row.audienceType, p.gameSessionName || p.gameSession,
      p.groupTypeName, ['SEASON', 'SEASON_GROUP'].includes(row.audienceType) ? paymentNames[p.paymentScope || 'ALL'] : '', memberNames[p.memberScope], p.openId ? `用户尾号 ${p.openId.slice(-6)}` : ''].filter(Boolean).join(' · ');
  } catch { return audienceNames[row.audienceType] || row.audienceType; }
}
// Scope unfinished sends to the logged-in administrator and backend, never persist credentials.
export function pendingKey(): string {
  const token = localStorage.getItem('authToken') || '';
  const payload = token.replace(/^Bearer\s+/i, '').split('.')[1];
  if (!payload) throw new Error('请先登录后台');
  const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
  const actor = JSON.parse(atob(normalized)).sub;
  if (!actor) throw new Error('无法识别后台账号，请重新登录');
  return `system-notification:pending:${baseUrl}:${actor}`;
}
export function requestId(): string {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
  const h = Array.from(bytes, n => n.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}